/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ played: NonNullable<unknown>, total: NonNullable<unknown> }} Event_ProgressInputs */

const th_event_progress = /** @type {(inputs: Event_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`จบการแข่งขันแล้ว ${i?.played} จาก ${i?.total} เกม`)
};

const en_event_progress = /** @type {(inputs: Event_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.played} of ${i?.total} games finished`)
};

const ja_event_progress = /** @type {(inputs: Event_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`全${i?.total}試合中${i?.played}試合終了`)
};

const zh_event_progress = /** @type {(inputs: Event_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已完成 ${i?.total} 场中的 ${i?.played} 场`)
};

const es_event_progress = /** @type {(inputs: Event_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.played} de ${i?.total} partidos disputados`)
};

const pt_event_progress = /** @type {(inputs: Event_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.played} de ${i?.total} jogos realizados`)
};

const id_event_progress = /** @type {(inputs: Event_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.played} dari ${i?.total} pertandingan selesai`)
};

const fr_event_progress = /** @type {(inputs: Event_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.played} matchs sur ${i?.total} disputés`)
};

const tl_event_progress = /** @type {(inputs: Event_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.played} sa ${i?.total} larong natapos`)
};

const vi_event_progress = /** @type {(inputs: Event_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đã đấu ${i?.played} trên ${i?.total} trận`)
};

const ko_event_progress = /** @type {(inputs: Event_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.total}경기 중 ${i?.played}경기 완료`)
};

const de_event_progress = /** @type {(inputs: Event_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.played} von ${i?.total} Spielen gespielt`)
};

const ru_event_progress = /** @type {(inputs: Event_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Сыграно ${i?.played} из ${i?.total} матчей`)
};

const tr_event_progress = /** @type {(inputs: Event_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.total} maçın ${i?.played} tanesi oynandı`)
};

const it_event_progress = /** @type {(inputs: Event_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.played} partite giocate su ${i?.total}`)
};

const pl_event_progress = /** @type {(inputs: Event_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rozegrano ${i?.played} z ${i?.total} meczów`)
};

const uk_event_progress = /** @type {(inputs: Event_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Зіграно ${i?.played} із ${i?.total} матчів`)
};

const hi_event_progress = /** @type {(inputs: Event_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.total} में से ${i?.played} मैच खेले गए`)
};

const ar_event_progress = /** @type {(inputs: Event_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`لُعبت ${i?.played} من ${i?.total} مباراة`)
};

const ms_event_progress = /** @type {(inputs: Event_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.played} daripada ${i?.total} perlawanan selesai`)
};

const bn_event_progress = /** @type {(inputs: Event_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.total}টির মধ্যে ${i?.played}টি খেলা হয়েছে`)
};

const zh_tw2_event_progress = /** @type {(inputs: Event_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已完成 ${i?.total} 場中的 ${i?.played} 場`)
};

const zh_hk2_event_progress = /** @type {(inputs: Event_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已完成 ${i?.total} 場中的 ${i?.played} 場`)
};

const ur_event_progress = /** @type {(inputs: Event_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.total} میں سے ${i?.played} میچ ہو چکے`)
};

const fa_event_progress = /** @type {(inputs: Event_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.played} بازی از ${i?.total} انجام شده`)
};

const sw_event_progress = /** @type {(inputs: Event_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Michezo ${i?.played} kati ya ${i?.total} imechezwa`)
};

const nl_event_progress = /** @type {(inputs: Event_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.played} van ${i?.total} wedstrijden gespeeld`)
};

/**
* | output |
* | --- |
* | "{played} of {total} games finished" |
*
* @param {Event_ProgressInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const event_progress = /** @type {((inputs: Event_ProgressInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_ProgressInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_event_progress(inputs)
	if (locale === "ja") return ja_event_progress(inputs)
	if (locale === "zh") return zh_event_progress(inputs)
	if (locale === "es") return es_event_progress(inputs)
	if (locale === "pt") return pt_event_progress(inputs)
	if (locale === "id") return id_event_progress(inputs)
	if (locale === "fr") return fr_event_progress(inputs)
	if (locale === "tl") return tl_event_progress(inputs)
	if (locale === "vi") return vi_event_progress(inputs)
	if (locale === "ko") return ko_event_progress(inputs)
	if (locale === "de") return de_event_progress(inputs)
	if (locale === "ru") return ru_event_progress(inputs)
	if (locale === "tr") return tr_event_progress(inputs)
	if (locale === "it") return it_event_progress(inputs)
	if (locale === "pl") return pl_event_progress(inputs)
	if (locale === "uk") return uk_event_progress(inputs)
	if (locale === "hi") return hi_event_progress(inputs)
	if (locale === "ar") return ar_event_progress(inputs)
	if (locale === "ms") return ms_event_progress(inputs)
	if (locale === "bn") return bn_event_progress(inputs)
	if (locale === "zh-TW") return zh_tw2_event_progress(inputs)
	if (locale === "zh-HK") return zh_hk2_event_progress(inputs)
	if (locale === "ur") return ur_event_progress(inputs)
	if (locale === "fa") return fa_event_progress(inputs)
	if (locale === "sw") return sw_event_progress(inputs)
	if (locale === "nl") return nl_event_progress(inputs)
	return en_event_progress(inputs)
});